import React, { useState } from "react";
import Day1Card from "../../day1_card/Day1_Card";
import Day2Card from "../../day2_card/Day2_Card";
import Day3Card from "../../day3_card/Day3_Card";
import { Accordion } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Inner_Transfered_Card from "./inner_transfered_card/Inner_Transfered_Card";

const Transfers = ({ data }) => {
  const [activeTab, setActiveTab] = useState("Itinerary");
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

 
  const icons = {
    meal: "/assets/images/cruise/itenarary/day-meal.png",
    checkout: "/assets/images/cruise/itenarary/checkout.png",
    car: "/assets/images/cruise/itenarary/private-tranfer.png",
    bed: "/assets/images/cruise/itenarary/bed-img.png",
    map: "/assets/images/cruise/itenarary/activity.png",
    flight: "/assets/images/cruise/itenarary/flight1.png",
  };


  return (
    <div className="Itinerary_Tab">
      <>
        <div className="city_header">
          {data?.title} - <span>{data?.duration}</span>
        </div>

        <Accordion defaultActiveKey="0" className="custom_accordion">
          {data?.itineraries?.map((d, index) => (
            <Accordion.Item eventKey={index.toString()} >
              <Accordion.Header>
                {d?.title}

                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="inner_icon down_icon"
                  />
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className="inner_icon up_icon"
                  />
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <Inner_Transfered_Card
                  item={d}
                  icons={icons}
                />
              </Accordion.Body>
            </Accordion.Item>
          ))}

        </Accordion>
      </>
    </div>
  );
};

export default Transfers;
